var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3568 6.58287L11.8823 2.60107C12.9699 2.63303 13.877 3.41053 14.0128 4.43947L14.5221 8.2993L14.6147 9.00001L21.4637 9.00001C22.0403 9.00001 22.4476 9.53501 22.2653 10.053L19.5529 17.7591C19.208 18.7391 18.2396 19.4001 17.1488 19.4001L10.4547 19.4002L6.91306 18.0585L6.91306 9.65624L8.66662 9.3241C10.0927 9.05392 11.1763 7.94984 11.3567 6.58321L11.3568 6.58287ZM5.98478 8.20001L8.33549 7.75484C9.04844 7.61966 9.59032 7.0677 9.68044 6.38432L10.2148 2.33591C10.3155 1.57271 11.0005 1 11.8126 1C13.7828 1 15.445 2.38949 15.6893 4.24105L16.1062 7.4L21.4637 7.4C23.1935 7.4 24.415 9.0048 23.868 10.5589L21.1558 18.265C20.5809 19.8982 18.9668 21 17.1488 21L10.1293 21L9.97831 20.9429L5.9057 19.4L1 19.4L0.999999 8.2L5.98478 8.20001ZM5.22375 9.80002L2.68956 9.80002L2.68956 17.8L5.22375 17.8L5.22375 9.80002Z",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.1dd96077.svg";
export { ForwardRef as ReactComponent };